import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Circle, G } from "react-native-svg";
import { isWeb } from "@madmedical/utils";
import { coordIdFactory } from "./utils";
import { colors } from "./useStyles";
export default function ManualMeasures({ graphData = {}, tooltip = {}, }) {
    const { manualMeasures: coords = [], randomIdFragment = "", type = "", } = graphData;
    return (_jsx(_Fragment, { children: coords.length > 0 &&
            coords.map(({ x, yHigh, yLow }, i) => {
                const idHigh = coordIdFactory({
                    randomIdFragment,
                    coord: coords[i],
                });
                const idLow = coordIdFactory({
                    randomIdFragment,
                    coord: coords[i],
                });
                return isWeb ? (_jsxs(G, { children: [yHigh && (_jsx(Circle, { fill: colors.white, strokeWidth: "2", stroke: tooltip.onShow && tooltip.id === idHigh
                                ? colors.grey800
                                : colors.grey400, id: idHigh, cx: x, cy: yHigh, r: "4" })), type === "line-paired" && yLow && (_jsx(Circle, { fill: colors.white, strokeWidth: "2", stroke: tooltip.onShow && tooltip.id === idLow
                                ? colors.grey800
                                : colors.grey400, id: idLow, cx: x, cy: yLow, r: "4" }))] }, idHigh + idLow)) : (_jsxs(G, Object.assign({ scaleY: -1 }, { children: [yHigh && (_jsx(Circle, { fill: colors.white, strokeWidth: "2", stroke: tooltip.onShow && tooltip.id === idHigh
                                ? colors.grey800
                                : colors.grey400, id: idHigh, cx: x, cy: yHigh, r: "4" })), type === "line-paired" && yLow && (_jsx(Circle, { fill: colors.white, strokeWidth: "2", stroke: tooltip.onShow && tooltip.id === idLow
                                ? colors.grey800
                                : colors.grey400, id: idLow, cx: x, cy: yLow, r: "4" }))] }), idHigh + idLow));
            }) }));
}
